import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { UserService } from '../../shared/services/user.service';
import { api } from '../../utils/endpoints';
import { fileDirectories } from '../../utils/view-settings';

import { HowToScoreArray, LIMIT, MAX_SIZE } from '../../utils/constants';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ScoreDetailsComponent } from '../../shared/popups/scoring-details/scoring-details.component';

import { ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbOffcanvas, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FilterModelComponent } from '../../shared/popups/filter-model/filter-model.component';
import { CommonDataSharingService } from '../../shared/services/common-data-sharing.service';
import { SafeHtmlPipe } from '../../shared/validators/safe-html.pipe';
import { ICONS } from '../../utils/svg-icons';

@Component({
  selector: 'app-leaderboard',
  imports: [CommonModule, InfiniteScrollModule, NgbTooltipModule, SafeHtmlPipe],
  templateUrl: './leaderboard.component.html',
  styleUrl: './leaderboard.component.scss',
})
export class LeaderboardComponent {
  pagination = { limit: LIMIT, maxSize: MAX_SIZE, skip: 0, totalItems: 0, row: 0, text: 'Loading...' };
  fileDirectoriesPath: any = fileDirectories.profile;
  leaderBoard: any = [];
  userDetail: any;
  currentUserRank: any;
  userInfo: any;
  range: any;

  appliedFilters: any = [];
  selectedFilters: any;
  ICONS = ICONS;
  private offcanvasService = inject(NgbOffcanvas);
  constructor(
    private _ngbModal: NgbModal,
    private cdr: ChangeDetectorRef,
    private _apiService: ApiCallsService,
    private _userService: UserService,
    private _commonDataService: CommonDataSharingService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
  ) {
    this._activatedRoute.queryParams.subscribe((params: any) => {
      if (params.filter && params.selectedFilters) {
        this.selectedFilters = JSON.parse(params.selectedFilters);
        this.appliedFilters = JSON.parse(params.selectedFilters);
      }
      if (params.range && params.range != null) {
        this.range = JSON.parse(params.range);
      }
      if ((params.filter && params.selectedFilters) || (params.range && params.range != null)) {
        this._getleaderBoard(1);
      }
    });
  }

  ngOnInit(): void {
    this._getleaderBoard(1);
    this._userService.user.subscribe((user: any) => {
      this.userDetail = user ?? null;
    });
  }
  private _getleaderBoard(page: number): void {
    this._apiService.post(api._leaderboard, this._getRequest(page)).subscribe({
      next: (res: any) => {
        this.currentUserRank = res?.data.currentUserRank;
        if (res?.data.currentUserRank) {
          this.currentUserRank.sports = this.currentUserRank.sports ? this.currentUserRank.sports.split(',') : [];
        }
        this.leaderBoard = res?.data.leaderboard;
        this.pagination.totalItems = res?.data.count;
        this.pagination.row = res?.data.length;
        this.pagination.text = 'No record found!';
        let array: any = [];
        if (res?.data.currentUserRank) {
          array.push(res?.data.currentUserRank.id);
        }
        this.leaderBoard = this.leaderBoard.filter((item: any) => !array.includes(item.id));
        this.leaderBoard.map((item: any, index: any) => {
          this.leaderBoard[index].sports = this.leaderBoard[index].sports ? this.leaderBoard[index].sports.split(',') : [];
        });
        this.cdr.detectChanges();
      },
      error: (error: any) => console.log(error),
    });
  }

  private _getRequest(page: any): HttpParams {
    let currentPage = Number.isNaN(this.pagination.skip) || this.pagination.skip == 0 ? 1 : this.pagination.skip;
    this.pagination.skip = currentPage;
    let params: any = {};
    // params['page']= currentPage;
    params['limit'] = 1000;
    let selectedFilter: any = [];
    if (this.selectedFilters != null) {
      if (this.selectedFilters && this.selectedFilters.length > 0) {
        this.selectedFilters.map((item: any) => {
          selectedFilter.push(item.toLowerCase().toString());
        });

        params['userLevel'] = selectedFilter;
      }
    }
    if (this.range && this.range?.clear == false) {
      params['minPoints'] = this.range?.min;
      params['maxPoints'] = this.range?.max;
    }
    return params;
  }
  onScroll(e: any) {
    if (this.pagination.skip * 10 > this.pagination.totalItems) {
      console.log('No more items');
      return;
    }

    this.pagination.skip = this.pagination.skip + 1;
    this._getleaderBoard(this.pagination.skip);
  }
  showScoring() {
    const HowToScorePopup = this.offcanvasService.open(ScoreDetailsComponent, {
      position: 'end',
      backdrop: true,
    });
    HowToScorePopup.componentInstance.HowToScoreArray = [...HowToScoreArray];
  }
  formatLevel(input: any, white: any) {
    return this._commonDataService.formatLevel(input, white);
  }
  userSearch(data: any) {
    this._router.navigate(['/user/feed/' + data?.id]);
  }
  // filter
  openFilterPopup(): void {
    this._commonDataService.getUserLevelTypesFilters().subscribe({
      next: (res: any) => {
        if (res) {
          const filterPopup = this._ngbModal.open(FilterModelComponent, {
            size: 'lg',
            centered: true,
            scrollable: false,
            backdrop: 'static',
            keyboard: false,
            windowClass: 'filterSmall',
          });
          filterPopup.componentInstance.filtersList = res;
          filterPopup.componentInstance.range = this.range;
          filterPopup.componentInstance.appliedFilters = this.appliedFilters;
          filterPopup.result.then((result: any) => {
            if (result) {
              this._router.navigate(['leaderboard'], {
                queryParams: {
                  selectedFilters: JSON.stringify(result.selectedFilters),
                  filter: result,
                  range: JSON.stringify(result.range),
                },
              });
            }
          });
        }
      },
    });
  }
}
